"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchToken = void 0;
var config_1 = require("../helpers/config");
var handleFetchErrors_1 = require("../helpers/handleFetchErrors");
var handle401 = function (response) {
    if (response.status === 401) {
        return response.json().then(function (e) {
            if (e.status) {
                throw e;
            }
            throw __assign(__assign({}, e), { status: response.status });
        });
    }
    return response;
};
var getReferrerUrl = function () {
    var urlParams = '';
    var location = window.location;
    var currentUrl = location.href;
    var search = location.search;
    var searchParams = new URLSearchParams(search);
    if (!searchParams.has('referrer_url') && document.referrer) {
        searchParams.append('referrer_url', document.referrer);
        urlParams = '?' + searchParams.toString();
        currentUrl = search
            ? currentUrl.replace(search, urlParams)
            : currentUrl + urlParams;
    }
    return currentUrl;
};
var fetchToken = function () {
    var currentUrl = getReferrerUrl();
    var url = (0, config_1.getLoginUrl)() + "/api/v1/authentication/refresh?currentUrl=" + encodeURIComponent(currentUrl);
    return fetch(url, { credentials: 'include' })
        .then(handle401)
        .then(handleFetchErrors_1.default)
        .then(function (res) { return res.json(); });
};
exports.fetchToken = fetchToken;
